import { Empty } from "zhs-components";
import CardHeader from "../../components/CardHeader.vue";
export default {
  props: {
    menu: Object
  },
  components: {
    Empty,
    CardHeader
  },

  created() {
    // this.getNewsList();
    this.getNewsClassifyList();
  },

  watch: {
    classifyId(val) {
      if (val) {
        this.getNewsList();
      }
    }

  },

  data() {
    return {
      newsList: [],
      mainRecommendNews: null,
      classifyList: [],
      classifyId: "",
      hiddenMoreClass: true
    };
  },

  methods: {
    async getNewsList() {
      this.mainRecommendNews = null;
      const res = (await this.$http.getHomeNews({
        num: this.menu.num,
        menu_id: this.menu.id,
        classify_id: this.classifyId
      })) || [];
      console.log("新闻-首页", res);

      if (res.length && res[0].news_cover_url) {
        this.mainRecommendNews = res.shift();
        console.log(this.mainRecommendNews);
      }

      this.newsList = res;
    },

    async getNewsClassifyList() {
      const res = await this.$http.getNewsClassify({
        menu_id: this.menu.id
      });
      console.log("getNewsClassifyList", res);
      this.classifyList = res;

      if (res && res.length) {
        this.classifyId = res[0].id;
      }
    },

    searchCourseList(id) {
      this.classifyId = id; // this.getNewsList();
    }

  }
};